// eslint-disable-next-line jira/restricted/react-component-props
import React, { type ComponentProps } from 'react';
import Placeholder from '@atlassian/jira-placeholder/src/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';
import type { AutomationChangeboarding as AutomationChangeboardingType } from './main.tsx';

/**
 * @deprecated This is a Nav3 component. If you do any changes here, please apply and QA them at Nav4 component as well: src/packages/navigation-apps/sidebar-nav4/project-settings
 */
const RLLAsyncAutomationChangeboarding = lazyForPaint(() =>
	import(/* webpackChunkName: "async-automation-changeboarding" */ './main').then(
		(exportedModule) => exportedModule.AutomationChangeboarding,
	),
);

export const AsyncAutomationChangeboarding = (
	props: JSX.LibraryManagedAttributes<
		typeof AutomationChangeboardingType,
		ComponentProps<typeof AutomationChangeboardingType>
	>,
) => (
	<Placeholder name="async-automation-changeboarding" fallback={<></>}>
		<RLLAsyncAutomationChangeboarding {...props} />
	</Placeholder>
);
